<template>
    <div></div>
</template>

<script>
export default {
  data () {
    return {}
  },
  props: {
    service: {
      type: Object,
      required: true
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/price/None.vue